<template>
	<div class="l-container">
		<div class="error">
			<strong class="tit">Error</strong>
			<div class="error-msg">
				<strong>요청하신 페이지를 찾을 수 없습니다.</strong>
				<p>
					<span
						>해당 페이지는 경로가 변경되었거나, 서버에 존재하지 않습니다.</span
					>
					<span
						>파일의 경로가 정확한지, URL 주소를 바르게 입력했는지
						확인해주세요.</span
					>
				</p>
				<div class="btn-area">
					<a
						href="javascript:;"
						@click="hasHistory ? $router.go(-1) : $router.push('/main')"
						>뒤로 가기</a
					>
					<router-link to="/main" class="go-main"
						>메인 페이지로 이동</router-link
					>
				</div>
			</div>
			<div class="l-pc">
				<div class="address">
					<br />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "ErrorPage",
	metaInfo: {
		title: "Error",
	},
	data() {
		return {
			currentRoute: window.location.pathname,
		};
	},
	mounted: function () {},
	computed: {
		hasHistory() {
			return window.history.length > 2;
		},
	},
	components: {
		//    'app-header': Header,
		//    'app-footer': Footer
	},
};
</script>

<style scoped>
.error {
	max-width: 1280px;
	margin: 0 auto;
	padding: 80px 20px;
	text-align: center;
}
.error .tit {
	font-weight: 300;
	letter-spacing: -2px;
}
.error .btn-area {
	display: flex;
}
.error a {
	flex: 1;
	font-weight: 600;
	color: #fff;
	text-align: center;
	background-color: #333;
	line-height: 42px;
	font-size: 1.6rem;
}
.error a.go-main {
	background-color: #eb2910;
}
.error a + a {
	margin-left: 10px;
}

@media screen and (max-width: 1279px) {
	.error .tit {
		font-size: 4rem;
	}
	.error .error-msg {
		margin-top: 20px;
		line-height: 1.5;
		font-size: 2.4rem;
	}

	.error .error-msg p {
		font-size: 1.6rem;
		line-height: 1.5;
		margin-top: 40px;
	}
	.error .btn-area {
		width: 100%;
		margin-top: 40px;
		margin-left: auto;
		margin-right: auto;
	}
}
@media screen and (min-width: 1280px) {
	.error .tit {
		font-size: 8rem;
	}
	.error .error-msg {
		margin-top: 40px;
		font-size: 2.8rem;
	}

	.error .error-msg p {
		font-size: 1.6rem;
		line-height: 1.5;
		margin-top: 40px;
	}
	.error .error-msg p span {
		display: block;
	}
	.error .btn-area {
		width: 410px;
		margin-top: 40px;
		margin-left: auto;
		margin-right: auto;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/ErrorPage.vue